<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioFeriado" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-5 col-12">
                            <mat-label>Data do Feriado</mat-label>
                            <input matInput [matDatepicker]="dataFeriadoDP" formControlName="dataFeriado"
                                id="dataFeriado" name="dataFeriado">
                            <mat-datepicker-toggle matSuffix [for]="dataFeriadoDP"></mat-datepicker-toggle>
                            <mat-datepicker #dataFeriadoDP></mat-datepicker>

                            <mat-error *ngIf="formularioFeriado.controls.dataFeriado.hasError('required')">
                                O campo Data do Feriado está inválido.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-7 col-12">
                            <mat-label>Descrição</mat-label>
                            <input matInput value="Descrição" class="form-control" id="descricaoFeriado" required
                                trim="blur" name="nome" formControlName="descricaoFeriado" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioFeriado.controls.descricaoFeriado.hasError('required')">
                                O campo Descrição é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioFeriado.controls.descricaoFeriado.hasError('minlength')">
                                O campo Descrição precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioFeriado.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>